// extracted by mini-css-extract-plugin
export default {"container":"ModularComponentActionButtons__container___onilc","applyButton":"ModularComponentActionButtons__applyButton___UFVZ5","icon":"ModularComponentActionButtons__icon___lW9N4"};